import MoreMoviesBy from './MoreMoviesBy';

export default MoreMoviesBy;
